import ReportManagement from "../components/Report-management"

export const authAction = {
    OWNER_LOGIN_INITIATE: 'OWNER_LOGIN_INITIATE',
    OWNER_LOGIN_SUCCESS: 'OWNER_LOGIN_SUCCESS',
    OWNER_LOGIN_FAILURE: 'OWNER_LOGIN_FAILURE',

    OWNER_CHANGE_PASSWORD_INITIATE: "OWNER_CHANGE_PASSWORD_INITIATE",
    OWNER_CHANGE_PASSWORD_SUCCESS: "OWNER_CHANGE_PASSWORD_SUCCESS",
    OWNER_CHANGE_PASSWORD_FAILURE: "OWNER_CHANGE_PASSWORD_FAILURE",

    OWNER_LOGOUT_INITIATE: "OWNER_LOGOUT_INITIATE",
    OWNER_LOGOUT_SUCCESS: "OWNER_LOGOUT_SUCCESS",
    OWNER_LOGOUT_FAILURE: "OWNER_LOGOUT_FAILURE",

    SEND_OTP_INITIATE: 'SEND_OTP_INITIATE',
    SEND_OTP_SUCCESS: 'SEND_OTP_SUCCESS',
    SEND_OTP_FAILURE: 'SEND_OTP_FAILURE',


    FORGOT_SEND_OTP_INITIATE: 'FORGOT_SEND_OTP_INITIATE',
    FORGOT_SEND_OTP_SUCCESS: 'FORGOT_SEND_OTP_SUCCESS',
    FORGOT_SEND_OTP_FAILURE: 'FORGOT_SEND_OTP_FAILURE',

    VERIFY_OTP_INITIATE: 'VERIFY_OTP_INITIATE',
    VERIFY_OTP_SUCCESS: 'VERIFY_OTP_SUCCESS',
    VERIFY_OTP_FAILURE: 'VERIFY_OTP_FAILURE',

    FORGOT_PASSWORD_INITIATE: 'FORGOT_PASSWORD_INITIATE',
    FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
    FORGOT_PASSWORD_FAILURE: 'FORGOT_PASSWORD_FAILURE',

    OWNER_SIGNUP_INITIATE: 'OWNER_SIGNUP_INITIATE',
    OWNER_SIGNUP_SUCCESS: 'OWNER_SIGNUP_SUCCESS',
    OWNER_SIGNUP_FAILURE: 'OWNER_SIGNUP_FAILURE',

    OWNER_CATEGORY_INITIATE: 'OWNER_CATEGORY_INITIATE',
    OWNER_CATEGORY_SUCCESS: 'OWNER_CATEGORY_SUCCESS',
    OWNER_CATEGORY_FAILURE: 'OWNER_CATEGORY_FAILURE',

    GET_COUNTRIES_LIST_INITIATE:"GET_COUNTRIES_LIST_INITIATE",
    GET_COUNTRIES_LIST_SUCCESS:"GET_COUNTRIES_LIST_SUCCESS",
    GET_COUNTRIES_LIST_FAILURE:"GET_COUNTRIES_LIST_FAILURE",

    GET_CITIES_LIST_INITIATE:"GET_CITIES_LIST_INITIATE",
    GET_CITIES_LIST_SUCCESS:"GET_CITIES_LIST_SUCCESS",
    GET_CITIES_LIST_FAILURE:"GET_CITIES_LIST_FAILURE",

    GET_STATE_LIST_INITIATE:"GET_STATE_LIST_INITIATE",
    GET_STATE_LIST_SUCCESS:"GET_STATE_LIST_SUCCESS",
    GET_STATE_LIST_FAILURE:"GET_STATE_LIST_FAILURE",

    UPDATE_STORE_TRAFFIC_INITIATE:"UPDATE_STORE_TRAFFIC_INITIATE",
    UPDATE_STORE_TRAFFIC_SUCCESS:"UPDATE_STORE_TRAFFIC_SUCCESS",
    UPDATE_STORE_TRAFFIC_FAILURE:"UPDATE_STORE_TRAFFIC_FAILURE",

 

}

export const dashboardAction = {


    OWNER_DASHBOARD_INITIATE: 'OWNER_DASHBOARD_INITIATE',
    OWNER_DASHBOARD_SUCCESS: 'OWNER_DASHBOARD_SUCCESS',
    OWNER_DASHBOARD_FAILURE: 'OWNER_DASHBOARD_FAILURE',
}

export const storeAction = {


    STORE_DETAILS_INITIATE: 'STORE_DETAILS_INITIATE',
    STORE_DETAILS_SUCCESS: 'STORE_DETAILS_SUCCESS',
    STORE_DETAILS_FAILURE: 'STORE_DETAILS_FAILURE',


    STORE_UPLOAD_INITIATE: 'STORE_UPLOAD_INITIATE',
    STORE_UPLOAD_SUCCESS: 'STORE_UPLOAD_SUCCESS',
    STORE_UPLOAD_FAILURE: 'STORE_UPLOAD_FAILURE',

    CHANGE_PAYMENT_STATUS_INITIATE:"CHANGE_PAYMENT_STATUS_INITIATE",
    CHANGE_PAYMENT_STATUS_SUCCESS: "CHANGE_PAYMENT_STATUS_SUCCESS",
    CHANGE_PAYMENT_STATUS_FAILURE: "CHANGE_PAYMENT_STATUS_FAILURE",
}

export const productAction = {
    PRODUCT_DETAILS_INITIATE: 'PRODUCT_DETAILS_INITIATE',
    PRODUCT_DETAILS_SUCCESS: 'PRODUCT_DETAILS_SUCCESS',
    PRODUCT_DETAILS_FAILURE: 'PRODUCT_DETAILS_FAILURE',


    PRODUCT_LIST_INITIATE: 'PRODUCT_LIST_INITIATE',
    PRODUCT_LIST_SUCCESS: 'PRODUCT_LIST_SUCCESS',
    PRODUCT_LIST_FAILURE: 'PRODUCT_LIST_FAILURE',

    REMOVE_PRODUCT_INITIATE: 'REMOVE_PRODUCT_INITIATE',
    REMOVE_PRODUCT_SUCCESS: 'REMOVE_PRODUCT_SUCCESS',
    REMOVE_PRODUCT_FAILURE: 'REMOVE_PRODUCT_FAILURE',

    PRODUCT_STATUS_INITIATE: 'PRODUCT_STATUS_INITIATE',
    PRODUCT_STATUS_SUCCESS: 'PRODUCT_STATUS_SUCCESS',
    PRODUCT_STATUS_FAILURE: 'PRODUCT_STATUS_FAILURE',

    PRODUCT_ADD_INITIATE: 'PRODUCT_ADD_INITIATE',
    PRODUCT_ADD_SUCCESS: 'PRODUCT_ADD_SUCCESS',
    PRODUCT_ADD_FAILURE: 'PRODUCT_ADD_FAILURE',

    PRODUCT_EDIT_INITIATE: 'PRODUCT_EDIT_INITIATE',
    PRODUCT_EDIT_SUCCESS: 'PRODUCT_EDIT_SUCCESS',
    PRODUCT_EDIT_FAILURE: 'PRODUCT_EDIT_FAILURE',

    GET_SUB_CATEGORY_LIST_INITIATE: "GET_SUB_CATEGORY_LIST_INITIATE",
    GET_SUB_CATEGORY_LIST_SUCCESS: "GET_SUB_CATEGORY_LIST_SUCCESS",
    GET_SUB_CATEGORY_LIST_FAILURE: "GET_SUB_CATEGORY_LIST_FAILURE",

    REQUEST_SUB_CATEGORY_INITIATE: "REQUEST_SUB_CATEGORY_INITIATE",
    REQUEST_SUB_CATEGORY_SUCCESS: "REQUEST_SUB_CATEGORY_SUCCESS",
    REQUEST_SUB_CATEGORY_FAILURE: "REQUEST_SUB_CATEGORY_FAILURE",

    ORDER_LIST_INITIATE:"ORDER_LIST_INITIATE",
    ORDER_LIST_SUCCESS:"ORDER_LIST_SUCCESS",
    ORDER_LIST_FAILURE:"ORDER_LIST_FAILURE",
  
    ORDER_DETAILS_INITIATE:"ORDER_DETAILS_INITIATE",
    ORDER_DETAILS_SUCCESS:"ORDER_DETAILS_SUCCESS",
    ORDER_DETAILS_FAILURE:"ORDER_DETAILS_FAILURE",
  
    TRANSACTION_LIST_INITIATE:"TRANSACTION_LIST_INITIATE",
    TRANSACTION_LIST_SUCCESS:"TRANSACTION_LIST_SUCCESS",
    TRANSACTION_LIST_FAILURE:"TRANSACTION_LIST_FAILURE",
  
    CHANGE_PAID_INITIATE:"CHANGE_PAID_INITIATE",
    CHANGE_PAID_SUCCESS:"CHANGE_PAID_SUCCESS",
    CHANGE_PAID_FAILURE:"CHANGE_PAID_FAILURE",
   
    STORE_TRANSACTION_LIST_INITIATE:"STORE_TRANSACTION_LIST_INITIATE",
    STORE_TRANSACTION_LIST_SUCCESS:"STORE_TRANSACTION_LIST_SUCCESS",
    STORE_TRANSACTION_LIST_FAILURE:"STORE_TRANSACTION_LIST_FAILURE",
  
    STORE_CHANGE_PAID_INITIATE:"STORE_CHANGE_PAID_INITIATE",
    STORE_CHANGE_PAID_SUCCESS:"STORE_CHANGE_PAID_SUCCESS",
    STORE_CHANGE_PAID_FAILURE:"STORE_CHANGE_PAID_FAILURE",
  
    STORE_MARK_ALL_PAID_INITIATE:"STORE_MARK_ALL_PAID_INITIATE",
    SOTRE_MARK_ALL_PAID_SUCCESS:"SOTRE_MARK_ALL_PAID_SUCCESS",
    STORE_MARK_ALL_PAID_FAILURE:"STORE_MARK_ALL_PAID_FAILURE",
  
    NOTIFICATION_STATUS_INITIATE:"NOTIFICATION_STATUS_INITIATE",
    NOTIFICATION_STATUS_SUCCESS:"NOTIFICATION_STATUS_SUCCESS",
    NOTIFICATION_STATUS_FAILURE:"NOTIFICATION_STATUS_FAILURE",

    CHANGE_ORDER_STATUS_INITIATE:"CHANGE_ORDER_STATUS_INITIATE",
    CHANGE_ORDER_STATUS_SUCCESS:"CHANGE_ORDER_STATUS_SUCCESS",
    CHANGE_ORDER_STATUS_FAILURE:"CHANGE_ORDER_STATUS_FAILURE"
}

export const orderAction = {

    // ORDER_LIST_INITIATE: "ORDER_LIST_INITIATE",
    // ORDER_LIST_SUCCESS: "ORDER_LIST_SUCCESS",
    // ORDER_LIST_FAILURE: "ORDER_LIST_FAILURE",

    // ORDER_DETAILS_INITIATE: "ORDER_DETAILS_INITIATE",
    // ORDER_DETAILS_SUCCESS: "ORDER_DETAILS_SUCCESS",
    // ORDER_DETAILS_FAILURE: "ORDER_DETAILS_FAILURE",

    CHANGE_ORDER_STATUS_INITIATE: "CHANGE_ORDER_STATUS_INITIATE",
    CHANGE_ORDER_STATUS_SUCCESS: "CHANGE_ORDER_STATUS_SUCCESS",
    CHANGE_ORDER_STATUS_FAILURE: "CHANGE_ORDER_STATUS_FAILURE",

   
}


export const ReportManagements = {
  
    TRANSACTION_REPORT_INITIATE:"TRANSACTION_REPORT_INITIATE",
    TRANSACTION_REPORT_SUCCESS:"TRANSACTION_REPORT_SUCCESS",
    TRANSACTION_REPORT_FAILURE:"TRANSACTION_REPORT_FAILURE",

    CUSTOMER_REPORT_INITIATE:"CUSTOMER_REPORT_INITIATE",
    CUSTOMER_REPORT_SUCCESS:"CUSTOMER_REPORT_SUCCESS",
    CUSTOMER_REPORT_FAILURE:"CUSTOMER_REPORT_FAILURE",

    PRODUCT_REPORT_INITIATE:"PRODUCT_REPORT_INITIATE",
    PRODUCT_REPORT_SUCCESS:"PRODUCT_REPORT_SUCCESS",
    PRODUCT_REPORT_FAILURE:"PRODUCT_REPORT_FAILURE",

    ORDER_REPORT_INITIATE:"ORDER_REPORT_INITIATE",
    ORDER_REPORT_SUCCESS:"ORDER_REPORT_SUCCESS",
    ORDER_REPORT_FAILURE:"ORDER_REPORT_FAILURE",

    ADMIN_PAYMENT_REPORT_INITIATE:"ADMIN_PAYMENT_REPORT_INITIATE",
    ADMIN_PAYMENT_REPORT_SUCCESS:"ADMIN_PAYMENT_REPORT_SUCCESS",
    ADMIN_PAYMENT_REPORT_FAILURE:"ADMIN_PAYMENT_REPORT_FAILURE"


}